import { Injectable} from '@angular/core';
import { catchError, forkJoin, Observable, of} from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';
import { environment } from '../environment';


@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  tokenKey = `${environment.appID}_reload_token__`;  
  userKey = `${environment.appID}_reload_user__`;    
  userLangaugeCodeKey = `${environment.appID}_user_language__`; 
  userCurrencyCodeKey = `${environment.appID}_user_currency__`; 
  domainSettingKey = `${environment.appID}_domain_setting__`;    
  passwordResetTokenKey = `${environment.appID}_pwd_reset_token__`; 
  publicKeyString:string = '';
  setKey(value:string){
    this.publicKeyString = value;
  }
  constructor(private localStorage: StorageMap) { }
  parseJsonString(jsonString:string){
    let jsonObj = {};
    try {
      jsonObj = JSON.parse(jsonString);
    } catch (e) {
      jsonObj = {};
    }
    return jsonObj;
  }
  get(key:string): Observable<any>{
    return this.localStorage.get(key);
  }
  set(key:string,value:any): Observable<any>{
    return this.localStorage.set(key, value || '');
  }
  delete(key:string): Observable<any>{
    return this.localStorage.delete(key);
  }
  clearAll(): Observable<any>{  
    return forkJoin([
      this.localStorage.delete(this.tokenKey).pipe(catchError((err: any) => {
          return of(<any>{});
      })),
      this.localStorage.delete(this.userKey).pipe(catchError((err: any) => {
          return of(<any>{});
      })),
      this.localStorage.delete(this.passwordResetTokenKey).pipe(catchError((err: any) => {
          return of(<any>{});
      }))
    ])
    //return this.localStorage.clear();
  } 




}
